import * as React from 'react';
import HeaderNav from 'components/headerNav';
import './teamDown.scss';

export default class TeamDown extends React.Component {

    render(): React.ReactNode {
        return (
            <div className="nomst-team-down-view">
                <HeaderNav />
                <div className="nomst-team-down-view__upper-body">
                    <img alt="" src={require('contents/gear-outage.svg')} className="gear-outage-icon"/>
                    <h2 className="nomst-team-down-view__header">
                        Team is temporarily unavailable
                    </h2>
                </div>
                <div className="nomst-team-down-view__lower-body">
                    <div className="nomst-team-down-view__lower-body-content">
                        <h3>
                            A couple of reasons for this issue:
                        </h3>
                        <ul className="explanation-items">
                            <li>
                                We may be performing regular system maintenance.
                            </li>
                            <li>
                                We may be experiencing unexpected problems that require an outage.
                            </li>
                        </ul>
                        <h3>
                            In either case, we are actively working to resolve access to Team as quickly as possible.
                        </h3>
                    </div>
                </div>
            </div>
        );
    }
}